import { Suspense } from "react";
import { Route } from "react-router-dom";

import { VerifiedRoute } from "@/components/common/verifiedRoute";
import Layout from "@/components/layout";
import { ProviderPortalShell } from "@/pages/providers/providerPortalShell";
import { lazy } from "@/utils/react/lazyWithRetries";

// Lazy load provider pages
const AccountContent = lazy(() =>
  import("@/pages/account").then((module) => ({
    default: module.AccountContent,
  }))
);
const ProviderHome = lazy(() =>
  import("@/pages/providers/home").then((module) => ({
    default: module.ProviderHome,
  }))
);
const VerifiedProviderRoutes = lazy(() =>
  import("@/pages/providers/home").then((module) => ({
    default: module.VerifiedProviderRoutes,
  }))
);
const ProviderOrderV2 = lazy(() =>
  import("@/pages/providers/orderV2").then((module) => ({
    default: module.ProviderOrder,
  }))
);
const ProviderIntake = lazy(() =>
  import("@/pages/providers/providerIntake").then((module) => ({
    default: module.ProviderIntake,
  }))
);
const ProviderResources = lazy(() =>
  import("@/pages/providers/resources").then((module) => ({
    default: module.ProviderResources,
  }))
);
const ProviderTests = lazy(() =>
  import("@/pages/providers/tests").then((module) => ({
    default: module.ProviderTests,
  }))
);
const WaitingForVerification = lazy(() =>
  import("@/pages/providers/waitingForVerification").then((module) => ({
    default: module.WaitingForVerification,
  }))
);

// Provider page loader
const ProviderPageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <div className="w-6 h-6 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin mx-auto mb-3"></div>
    </div>
  </div>
);

const ProviderAccountRoute = () => {
  return (
    <Layout title="My Account" full bgClass="bg-evvy-cream" noHeader noFooter>
      <ProviderPortalShell>
        <div className="mx-auto w-full max-w-6xl p-8">
          <AccountContent />
        </div>
      </ProviderPortalShell>
    </Layout>
  );
};

export const ProviderRoutes = () => {
  return (
    <Route
      path="/provider/*"
      element={
        <VerifiedRoute authRequired={true}>
          <Suspense fallback={<ProviderPageLoader />}>
            <ProviderHome />
          </Suspense>
        </VerifiedRoute>
      }
    >
      <Route
        path="intake/"
        element={
          <VerifiedRoute authRequired={true}>
            <Suspense fallback={<ProviderPageLoader />}>
              <ProviderIntake />
            </Suspense>
          </VerifiedRoute>
        }
      />
      <Route
        path="account/*"
        element={
          <VerifiedRoute authRequired={true}>
            <Suspense fallback={<ProviderPageLoader />}>
              <ProviderAccountRoute />
            </Suspense>
          </VerifiedRoute>
        }
      />
      <Route
        path="verify/"
        element={
          <VerifiedRoute authRequired={true}>
            <Suspense fallback={<ProviderPageLoader />}>
              <WaitingForVerification />
            </Suspense>
          </VerifiedRoute>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<ProviderPageLoader />}>
            <VerifiedProviderRoutes />
          </Suspense>
        }
      >
        <Route
          path="resources/"
          element={
            <VerifiedRoute authRequired={true}>
              <Suspense fallback={<ProviderPageLoader />}>
                <ProviderResources />
              </Suspense>
            </VerifiedRoute>
          }
        />
        <Route
          path="order/"
          element={
            <VerifiedRoute authRequired={true}>
              <Suspense fallback={<ProviderPageLoader />}>
                <ProviderOrderV2 />
              </Suspense>
            </VerifiedRoute>
          }
        />
        <Route
          path="tests/"
          element={
            <VerifiedRoute authRequired={true}>
              <Suspense fallback={<ProviderPageLoader />}>
                <ProviderTests />
              </Suspense>
            </VerifiedRoute>
          }
        />
      </Route>
    </Route>
  );
};
